export { default as translations } from './translations.json';

export const SUPPORTED_PROVIDERS = ['google', 'deepl'];

/**
 * Client-side translation request.
 * @param {string} text
 * @param {string} targetLang — ISO 639-1 code (e.g. 'en', 'fi', 'lv')
 * @param {string} [provider]
 * @returns {Promise<string>}
 */
export const translateMessage = async (text, targetLang, provider = 'google') => {
  const response = await fetch('/api/chat-translate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, targetLang, provider }),
    credentials: 'include',
  });
  if (!response.ok) throw new Error('Translation failed');
  const { translated } = await response.json();
  return translated;
};
